import {JbJobRunService} from './service/api/jb-job-run.service';
import {ENTITY_SERVICE_REGISTRY, EntityServiceEntry} from '../../core/shared/dto/dto-service/entity-service-registry';

export const JB_ENTITY_PROVIDER = [
    {
        provide: ENTITY_SERVICE_REGISTRY,
        useValue: [
            ['jb.JbJobRun', {route: '/jb/jbJobRuns', service: JbJobRunService}],
            ['jb.JbJobRunLogEntry', {route: '/jb/jbJobRunLogEntrys'}],
            ['jb.JbJobType', {route: '/jb/jbJobTypes'}],
        ] as EntityServiceEntry[],
        multi: true
    }
];
